<template>
	<q-layout view="hHh LpR fff">
		<q-header class="bg-white text-black" elevated reveal>
			<q-toolbar class=" q-pl-lg">
				<q-toolbar-title class="q-pt-md q-pb-md">
					<q-img src="/assets/images/Memo-Link-logo.svg"
					       fetchpriority="high"
					       height="48"
					       alt="Memo Link"
					       :style="{
                          width: (quasar.screen.xl||quasar.screen.lg ? 255: 220) +'px',
                          height: (quasar.screen.xl||quasar.screen.lg ? 48: 41) +'px'
                  }"
					       width="255"
					       class="logo cursor-pointer"
					       @click="onLogoClick"
					/>
				</q-toolbar-title>
				<UserMenu/>
			</q-toolbar>
		</q-header>

		<q-page-container class="fit row">
			<router-view/>
		</q-page-container>

		<Footer/>
	</q-layout>
</template>


<script setup>
import { useQuasar } from 'quasar'
import { inject, onMounted } from 'vue'
import { useStore } from 'vuex'
import { useRoute, useRouter } from 'vue-router'
import { bootstrap, optIn, optOut } from 'vue-gtag'

import UserMenu from './components/includes/UserMenu'
import Footer from './components/includes/Footer'

const router = useRouter();
const route = useRoute();
const store = useStore();
const quasar = useQuasar();
const appUrl = inject('appUrl').toString();
const eventBus = inject('eventBus');
const axios = inject('axios');

function onCookiesAccepted() {
    bootstrap().then(()=> optIn());
    axios.get('/sanctum/csrf-cookie');
}

function onCookiesRejected() {
    optOut();
    const Url = new URL(appUrl);
    const cookies = quasar.cookies.getAll();

    Object.keys(cookies).forEach((key) => {
        if (['_auth_token', 'XSRF-TOKEN'].includes(key) === false && key !== 'klaro') {
            quasar.cookies.remove(key, {path: '/'});
            quasar.cookies.remove(key, {path: '/', domain: `.${Url.host.substring(Url.host.indexOf('memo'))}`});
        }
    });
}

onMounted(() => {
    if (quasar.cookies.has('_auth_token') && !store.getters.isAuthenticated) {
        axios.defaults.headers.common['Authorization'] = `Bearer ${quasar.cookies.get('_auth_token')}`;
        axios
            .get('auth/check')
            .catch((reason) => {
                if (reason.response?.status === 401) {
                    quasar.cookies.remove('_auth_token', {path: '/'});
                    store.commit('logout');
                    delete axios.defaults.headers.common['Authorization'];
                    router.push({ name: 'home' })
                }
            })
            .then((response) => {
                if (response?.data) {
                    store.commit('auth', response.data.data)
                }
            });
    }
    store.dispatch('fetchLimits')
    const initRoute = document.getElementById('app').getAttribute('data-route')

    if (initRoute) {
        router.replace({ name: initRoute, params: { memoLink: '' } })
    }
});

function onLogoClick() {
    if (route?.name === 'home') {
        eventBus.emit('reset-ml-form');
    } else {
        router.push({name: 'home'});
    }
}

eventBus.on('subdomain-created', () => {
    const user = store.getters.user;
    user.subDomainCount++;
    store.commit('updateUser', user);
});

eventBus.on('cookies-accepted', onCookiesAccepted);
eventBus.on('cookies-rejected', onCookiesRejected);

</script>

<style>
body {
	background: #f5f5f5;
}
</style>
